module.exports = __webpack_public_path__ + "img/service_1.90fc0bd2.svg";